import React from "react";
import PropTypes from "prop-types";
import {
  APanel,
  APanelBody,
  APanelHeader,
  APanelTitle
} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import css from "./Card.module.scss";

const Card = ({title, icon, action, className, children}) => {
  return (
    <APanel className={classNames(css.card, className)}>
      <APanelHeader>
        <div
          className={classNames(
            css.fullWidth,
            "d-flex align-center flex-nowrap"
          )}>
          {icon && <div className="d-flex pr-2">{icon}</div>}
          {(title || action) && (
            <div
              className={classNames(
                css.fullWidth,
                css.title,
                "d-flex align-center space-between flex-nowrap"
              )}>
              {title && (
                <APanelTitle className={css.title}>{title}</APanelTitle>
              )}
              {action && <div>{action}</div>}
            </div>
          )}
        </div>
      </APanelHeader>
      <APanelBody className={css.cardBody}>{children}</APanelBody>
    </APanel>
  );
};

Card.propTypes = {
  // Option to pass in a title to the card header
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // Option to pass in an icon to the card header
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // Option to add a link to the card header
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // Optional additional classnames
  className: PropTypes.string,
  children: PropTypes.any
};

export default Card;
